export default __webpack_public_path__ + "static/media/NoPreviewAvailable.8835950e.png";